import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  red: {
    color: theme.palette.error.main,
  },
}));

export default useStyles;
